module.exports = __webpack_public_path__ + "static/media/headerlogo.5a377d49.png";